/**
 * Binding des code pays
 */
export default [
  {
    value: 'FR',
    label: 'France',
    englishLabel: 'France',
    isUeCountry: true
  },
  {
    value: 'PT',
    label: 'A\u00e7ores et Mad\u00e8re',
    englishLabel: 'Portugal',
    isUeCountry: false
  },
  {
    value: 'AF',
    label: 'Afghanistan',
    englishLabel: 'Afghanistan',
    isUeCountry: false
  },
  {
    value: 'ZA',
    label: 'Afrique du Sud',
    englishLabel: 'South Africa',
    isUeCountry: false
  },
  {
    value: 'AL',
    label: 'Albanie',
    englishLabel: 'Albania',
    isUeCountry: false
  },
  {
    value: 'DZ',
    label: 'Alg\u00e9rie',
    englishLabel: 'Algeria',
    isUeCountry: false
  },
  {
    value: 'DE',
    label: 'Allemagne',
    englishLabel: 'Germany',
    isUeCountry: true
  },
  {
    value: 'AD',
    label: 'Andorre',
    englishLabel: 'AndorrA',
    isUeCountry: false
  },
  {
    value: 'AO',
    label: 'Angola',
    englishLabel: 'Angola',
    isUeCountry: false
  },
  {
    value: 'AI',
    label: 'Anguilla',
    englishLabel: 'Anguilla',
    isUeCountry: false
  },
  {
    value: 'AG',
    label: 'Antigua-et-Barbuda',
    englishLabel: 'Antigua and Barbuda',
    isUeCountry: false
  },
  {
    value: 'SA',
    label: 'Arabie Saoudite',
    englishLabel: 'Saudi Arabia',
    isUeCountry: false
  },
  {
    value: 'AR',
    label: 'Argentine',
    englishLabel: 'Argentina',
    isUeCountry: false
  },
  {
    value: 'AM',
    label: 'Arm\u00e9nie',
    englishLabel: 'Armenia',
    isUeCountry: false
  },
  {
    value: 'AW',
    label: 'Aruba',
    englishLabel: 'Aruba',
    isUeCountry: false
  },
  {
    value: 'AU',
    label: 'Australie',
    englishLabel: 'Australia',
    isUeCountry: false
  },
  {
    value: 'AT',
    label: 'Autriche',
    englishLabel: 'Austria',
    isUeCountry: true
  },
  {
    value: 'AZ',
    label: 'Azerba\u00efdjan',
    englishLabel: 'Azerbaijan',
    isUeCountry: false
  },
  {
    value: 'BS',
    label: 'Bahamas',
    englishLabel: 'Bahamas',
    isUeCountry: false
  },
  {
    value: 'BH',
    label: 'Bahre\u00efn',
    englishLabel: 'Bahrain',
    isUeCountry: false
  },
  {
    value: 'BD',
    label: 'Bangladesh',
    englishLabel: 'Bangladesh',
    isUeCountry: false
  },
  {
    value: 'BB',
    label: 'Barbade',
    englishLabel: 'Barbados',
    isUeCountry: false
  },
  {
    value: 'BE',
    label: 'Belgique',
    englishLabel: 'Belgium',
    isUeCountry: true
  },
  {
    value: 'BZ',
    label: 'B\u00e9lize',
    englishLabel: 'Belize',
    isUeCountry: false
  },
  {
    value: 'BJ',
    label: 'B\u00e9nin',
    englishLabel: 'Benin',
    isUeCountry: false
  },
  {
    value: 'BM',
    label: 'Bermudes',
    englishLabel: 'Bermuda',
    isUeCountry: false
  },
  {
    value: 'BT',
    label: 'Bhoutan',
    englishLabel: 'Bhutan',
    isUeCountry: false
  },
  {
    value: 'BY',
    label: 'Bi\u00e9lorussie',
    englishLabel: 'Belarus',
    isUeCountry: false
  },
  {
    value: 'BO',
    label: 'Bolivie',
    englishLabel: 'Bolivia',
    isUeCountry: false
  },
  {
    value: 'BA',
    label: 'Bosnie-Herz\u00e9govine',
    englishLabel: 'Bosnia and Herzegovina',
    isUeCountry: false
  },
  {
    value: 'BW',
    label: 'Botswana',
    englishLabel: 'Botswana',
    isUeCountry: false
  },
  {
    value: 'BR',
    label: 'Br\u00e9sil',
    englishLabel: 'Brazil',
    isUeCountry: false
  },
  {
    value: 'BN',
    label: 'Brunei',
    englishLabel: 'Brunei Darussalam',
    isUeCountry: false
  },
  {
    value: 'BG',
    label: 'Bulgarie',
    englishLabel: 'Bulgaria',
    isUeCountry: true
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
    englishLabel: 'Burkina Faso',
    isUeCountry: false
  },
  {
    value: 'BI',
    label: 'Burundi',
    englishLabel: 'Burundi',
    isUeCountry: false
  },
  {
    value: 'KH',
    label: 'Cambodge',
    englishLabel: 'Cambodia',
    isUeCountry: false
  },
  {
    value: 'CM',
    label: 'Cameroun',
    englishLabel: 'Cameroon',
    isUeCountry: false
  },
  {
    value: 'CA',
    label: 'Canada',
    englishLabel: 'Canada',
    isUeCountry: false
  },
  {
    value: 'CV',
    label: 'Cap-Vert',
    englishLabel: 'Cape Verde',
    isUeCountry: false
  },
  {
    value: 'CL',
    label: 'Chili',
    englishLabel: 'Chile',
    isUeCountry: false
  },
  {
    value: 'CN',
    label: 'Chine',
    englishLabel: 'China',
    isUeCountry: false
  },
  {
    value: 'CY',
    label: 'Chypre',
    englishLabel: 'Cyprus',
    isUeCountry: true
  },
  {
    value: 'CO',
    label: 'Colombie',
    englishLabel: 'Colombia',
    isUeCountry: false
  },
  {
    value: 'KM',
    label: 'Comores',
    englishLabel: 'Comoros',
    isUeCountry: false
  },
  {
    value: 'CD',
    label: 'Congo (RDC)',
    englishLabel: 'Congo, The Democratic Republic of the',
    isUeCountry: false
  },
  {
    value: 'CG',
    label: 'Congo (R\u00e9publique)',
    englishLabel: 'Congo',
    isUeCountry: false
  },
  {
    value: 'KP',
    label: 'Cor\u00e9e du Nord',
    englishLabel: 'Korea, Democratic PeopleS Republic of',
    isUeCountry: false
  },
  {
    value: 'KR',
    label: 'Cor\u00e9e du Sud',
    englishLabel: 'Korea, Republic of',
    isUeCountry: false
  },
  {
    value: 'CR',
    label: 'Costa Rica',
    englishLabel: 'Costa Rica',
    isUeCountry: false
  },
  {
    value: 'CI',
    label: "C\u00f4te d'Ivoire",
    englishLabel: "Cote D'Ivoire",
    isUeCountry: false
  },
  {
    value: 'HR',
    label: 'Croatie',
    englishLabel: 'Croatia',
    isUeCountry: true
  },
  {
    value: 'CU',
    label: 'Cuba',
    englishLabel: 'Cuba',
    isUeCountry: false
  },
  {
    value: 'DK',
    label: 'Danemark',
    englishLabel: 'Denmark',
    isUeCountry: true
  },
  {
    value: 'DJ',
    label: 'Djibouti',
    englishLabel: 'Djibouti',
    isUeCountry: false
  },
  {
    value: 'DM',
    label: 'Dominique',
    englishLabel: 'Dominica',
    isUeCountry: false
  },
  {
    value: 'EG',
    label: '\u00c9gypte',
    englishLabel: 'Egypt',
    isUeCountry: false
  },
  {
    value: 'SV',
    label: 'El Salvador',
    englishLabel: 'El Salvador',
    isUeCountry: false
  },
  {
    value: 'AE',
    label: '\u00c9mirats arabes unis',
    englishLabel: 'United Arab Emirates',
    isUeCountry: false
  },
  {
    value: 'EC',
    label: '\u00c9quateur',
    englishLabel: 'Ecuador',
    isUeCountry: false
  },
  {
    value: 'ER',
    label: '\u00c9rythr\u00e9e',
    englishLabel: 'Eritrea',
    isUeCountry: false
  },
  {
    value: 'ES',
    label: 'Espagne',
    englishLabel: 'Spain',
    isUeCountry: true
  },
  {
    value: 'EE',
    label: 'Estonie',
    englishLabel: 'Estonia',
    isUeCountry: true
  },
  {
    value: 'US',
    label: '\u00c9tats-Unis',
    englishLabel: 'United States',
    isUeCountry: false
  },
  {
    value: 'ET',
    label: '\u00c9thiopie',
    englishLabel: 'Ethiopia',
    isUeCountry: false
  },
  {
    value: 'FJ',
    label: 'Fidji',
    englishLabel: 'Fiji',
    isUeCountry: false
  },
  {
    value: 'FI',
    label: 'Finlande',
    englishLabel: 'Finland',
    isUeCountry: true
  },
  {
    value: 'FR',
    label: 'France',
    englishLabel: 'France',
    isUeCountry: true
  },
  {
    value: 'GA',
    label: 'Gabon',
    englishLabel: 'Gabon',
    isUeCountry: false
  },
  {
    value: 'GM',
    label: 'Gambie',
    englishLabel: 'Gambia',
    isUeCountry: false
  },
  {
    value: 'GE',
    label: 'G\u00e9orgie',
    englishLabel: 'Georgia',
    isUeCountry: false
  },
  {
    value: 'GS',
    label: 'G\u00e9orgie du Sud et les \u00eeles Sandwich du Sud',
    englishLabel: 'South Georgia and the South Sandwich Islands',
    isUeCountry: false
  },
  {
    value: 'GH',
    label: 'Ghana',
    englishLabel: 'Ghana',
    isUeCountry: false
  },
  {
    value: 'GI',
    label: 'Gibraltar',
    englishLabel: 'Gibraltar',
    isUeCountry: false
  },
  {
    value: 'GR',
    label: 'Gr\u00e8ce',
    englishLabel: 'Greece',
    isUeCountry: true
  },
  {
    value: 'GD',
    label: 'Grenade',
    englishLabel: 'Grenada',
    isUeCountry: false
  },
  {
    value: 'GL',
    label: 'Groenland',
    englishLabel: 'Greenland',
    isUeCountry: false
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
    englishLabel: 'Guadeloupe',
    isUeCountry: false
  },
  {
    value: 'GU',
    label: 'Guam',
    englishLabel: 'Guam',
    isUeCountry: false
  },
  {
    value: 'GT',
    label: 'Guatemala',
    englishLabel: 'Guatemala',
    isUeCountry: false
  },
  {
    value: 'GN',
    label: 'Guin\u00e9e',
    englishLabel: 'Guinea',
    isUeCountry: false
  },
  {
    value: 'GW',
    label: 'Guin\u00e9e-Bissau',
    englishLabel: 'Guinea-Bissau',
    isUeCountry: false
  },
  {
    value: 'GQ',
    label: 'Guin\u00e9e \u00e9quatoriale',
    englishLabel: 'Equatorial Guinea',
    isUeCountry: false
  },
  {
    value: 'GY',
    label: 'Guyane',
    englishLabel: 'Guyana',
    isUeCountry: false
  },
  {
    value: 'GF',
    label: 'Guyane fran\u00e7aise',
    englishLabel: 'French Guiana',
    isUeCountry: false
  },
  {
    value: 'HT',
    label: 'Ha\u00efti',
    englishLabel: 'Haiti',
    isUeCountry: false
  },
  {
    value: 'HN',
    label: 'Honduras',
    englishLabel: 'Honduras',
    isUeCountry: false
  },
  {
    value: 'HK',
    label: 'Hong Kong',
    englishLabel: 'Hong Kong',
    isUeCountry: false
  },
  {
    value: 'HU',
    label: 'Hongrie',
    englishLabel: 'Hungary',
    isUeCountry: true
  },
  {
    value: 'CX',
    label: '\u00cele Christmas',
    englishLabel: 'Christmas Island',
    isUeCountry: false
  },
  {
    value: 'MU',
    label: '\u00cele Maurice',
    englishLabel: 'Mauritius',
    isUeCountry: false
  },
  {
    value: 'AX',
    label: '\u00celes \u00c5land',
    englishLabel: 'Åland Islands',
    isUeCountry: false
  },
  {
    value: 'KY',
    label: '\u00celes Ca\u00efmans',
    englishLabel: 'Cayman Islands',
    isUeCountry: false
  },
  {
    value: 'CC',
    label: '\u00celes Cocos (Keeling)',
    englishLabel: 'Cocos (Keeling) Islands',
    isUeCountry: false
  },
  {
    value: 'CK',
    label: '\u00celes Cook',
    englishLabel: 'Cook Islands',
    isUeCountry: false
  },
  {
    value: 'FO',
    label: '\u00celes F\u00e9ro\u00e9',
    englishLabel: 'Faroe Islands',
    isUeCountry: false
  },
  {
    value: 'FK',
    label: '\u00celes Malouines (\u00eeles Falkland)',
    englishLabel: 'Falkland Islands (Malvinas)',
    isUeCountry: false
  },
  {
    value: 'MP',
    label: '\u00celes Mariannes du Nord',
    englishLabel: 'Northern Mariana Islands',
    isUeCountry: false
  },
  {
    value: 'MH',
    label: '\u00celes Marshall',
    englishLabel: 'Marshall Islands',
    isUeCountry: false
  },
  {
    value: 'NF',
    label: '\u00celes Norfolk',
    englishLabel: 'Norfolk Island',
    isUeCountry: false
  },
  {
    value: 'SB',
    label: '\u00celes Salomon',
    englishLabel: 'Solomon Islands',
    isUeCountry: false
  },
  {
    value: 'TC',
    label: '\u00celes Turques-et-Ca\u00efques',
    englishLabel: 'Turks and Caicos Islands',
    isUeCountry: false
  },
  {
    value: 'VI',
    label: '\u00celes Vierges am\u00e9ricaines',
    englishLabel: 'Virgin Islands, U.S.',
    isUeCountry: false
  },
  {
    value: 'VG',
    label: '\u00celes Vierges britanniques',
    englishLabel: 'Virgin Islands, British',
    isUeCountry: false
  },
  {
    value: 'IN',
    label: 'Inde',
    englishLabel: 'India',
    isUeCountry: false
  },
  {
    value: 'ID',
    label: 'Indon\u00e9sie',
    englishLabel: 'Indonesia',
    isUeCountry: false
  },
  {
    value: 'IR',
    label: 'Iran',
    englishLabel: 'Iran, Islamic Republic Of',
    isUeCountry: false
  },
  {
    value: 'IQ',
    label: 'Iraq',
    englishLabel: 'Iraq',
    isUeCountry: false
  },
  {
    value: 'IE',
    label: 'Irlande',
    englishLabel: 'Ireland',
    isUeCountry: true
  },
  {
    value: 'IS',
    label: 'Islande',
    englishLabel: 'Iceland',
    isUeCountry: false
  },
  {
    value: 'IL',
    label: 'Isra\u00ebl',
    englishLabel: 'Israel',
    isUeCountry: false
  },
  {
    value: 'IT',
    label: 'Italie',
    englishLabel: 'Italy',
    isUeCountry: true
  },
  {
    value: 'JM',
    label: 'Jama\u00efque',
    englishLabel: 'Jamaica',
    isUeCountry: false
  },
  {
    value: 'JP',
    label: 'Japon',
    englishLabel: 'Japan',
    isUeCountry: false
  },
  {
    value: 'JE',
    label: 'Jersey',
    englishLabel: 'Jersey',
    isUeCountry: false
  },
  {
    value: 'JO',
    label: 'Jordanie',
    englishLabel: 'Jordan',
    isUeCountry: false
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
    englishLabel: 'Kazakhstan',
    isUeCountry: false
  },
  {
    value: 'KE',
    label: 'Kenya',
    englishLabel: 'Kenya',
    isUeCountry: false
  },
  {
    value: 'KG',
    label: 'Kirghizstan',
    englishLabel: 'Kyrgyzstan',
    isUeCountry: false
  },
  {
    value: 'KI',
    label: 'Kiribati',
    englishLabel: 'Kiribati',
    isUeCountry: false
  },
  {
    value: 'RS',
    label: 'Kosovo',
    englishLabel: 'Kosovo',
    isUeCountry: false
  },
  {
    value: 'KW',
    label: 'Kowe\u00eft',
    englishLabel: 'Kuwait',
    isUeCountry: false
  },
  {
    value: 'LA',
    label: 'Laos',
    englishLabel: 'Lao PeopleS Democratic Republic',
    isUeCountry: false
  },
  {
    value: 'LS',
    label: 'Lesotho',
    englishLabel: 'Lesotho',
    isUeCountry: false
  },
  {
    value: 'LV',
    label: 'Lettonie',
    englishLabel: 'Latvia',
    isUeCountry: true
  },
  {
    value: 'LB',
    label: 'Liban',
    englishLabel: 'Lebanon',
    isUeCountry: false
  },
  {
    value: 'LR',
    label: 'Lib\u00e9ria',
    englishLabel: 'Liberia',
    isUeCountry: false
  },
  {
    value: 'LY',
    label: 'Libye',
    englishLabel: 'Libyan Arab Jamahiriya',
    isUeCountry: false
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
    englishLabel: 'Liechtenstein',
    isUeCountry: false
  },
  {
    value: 'LT',
    label: 'Lituanie',
    englishLabel: 'Lithuania',
    isUeCountry: true
  },
  {
    value: 'LU',
    label: 'Luxembourg',
    englishLabel: 'Luxembourg',
    isUeCountry: true
  },
  {
    value: 'MO',
    label: 'Macau',
    englishLabel: 'Macao',
    isUeCountry: false
  },
  {
    value: 'MK',
    label: 'Mac\u00e9doine',
    englishLabel: 'Macedonia, The Former Yugoslav Republic of',
    isUeCountry: false
  },
  {
    value: 'MG',
    label: 'Madagascar',
    englishLabel: 'Madagascar',
    isUeCountry: false
  },
  {
    value: 'MY',
    label: 'Malaisie',
    englishLabel: 'Malaysia',
    isUeCountry: false
  },
  {
    value: 'MW',
    label: 'Malawi',
    englishLabel: 'Malawi',
    isUeCountry: false
  },
  {
    value: 'MV',
    label: 'Maldives',
    englishLabel: 'Maldives',
    isUeCountry: false
  },
  {
    value: 'ML',
    label: 'Mali',
    englishLabel: 'Mali',
    isUeCountry: false
  },
  {
    value: 'MT',
    label: 'Malte',
    englishLabel: 'Malta',
    isUeCountry: true
  },
  {
    value: 'MA',
    label: 'Maroc',
    englishLabel: 'Morocco',
    isUeCountry: false
  },
  {
    value: 'MQ',
    label: 'Martinique',
    englishLabel: 'Martinique',
    isUeCountry: false
  },
  {
    value: 'MR',
    label: 'Mauritanie',
    englishLabel: 'Mauritania',
    isUeCountry: false
  },
  {
    value: 'YT',
    label: 'Mayotte',
    englishLabel: 'Mayotte',
    isUeCountry: false
  },
  {
    value: 'MX',
    label: 'Mexique',
    englishLabel: 'Mexico',
    isUeCountry: false
  },
  {
    value: 'FM',
    label: 'Micron\u00e9sie',
    englishLabel: 'Micronesia, Federated States of',
    isUeCountry: false
  },
  {
    value: 'MD',
    label: 'Moldavie',
    englishLabel: 'Moldova, Republic of',
    isUeCountry: false
  },
  {
    value: 'MC',
    label: 'Monaco',
    englishLabel: 'Monaco',
    isUeCountry: false
  },
  {
    value: 'MN',
    label: 'Mongolie',
    englishLabel: 'Mongolia',
    isUeCountry: false
  },
  {
    value: 'ME',
    label: 'Mont\u00e9n\u00e9gro',
    englishLabel: 'Monténégro',
    isUeCountry: false
  },
  {
    value: 'MS',
    label: 'Montserrat',
    englishLabel: 'Montserrat',
    isUeCountry: false
  },
  {
    value: 'MZ',
    label: 'Mozambique',
    englishLabel: 'Mozambique',
    isUeCountry: false
  },
  {
    value: 'MM',
    label: 'Myanmar (Birmanie)',
    englishLabel: 'Myanmar',
    isUeCountry: false
  },
  {
    value: 'NA',
    label: 'Namibie',
    englishLabel: 'Namibia',
    isUeCountry: false
  },
  {
    value: 'NR',
    label: 'Nauru',
    englishLabel: 'Nauru',
    isUeCountry: false
  },
  {
    value: 'NP',
    label: 'N\u00e9pal',
    englishLabel: 'Nepal',
    isUeCountry: false
  },
  {
    value: 'NI',
    label: 'Nicaragua',
    englishLabel: 'Nicaragua',
    isUeCountry: false
  },
  {
    value: 'NE',
    label: 'Niger',
    englishLabel: 'Niger',
    isUeCountry: false
  },
  {
    value: 'NG',
    label: 'Nig\u00e9ria',
    englishLabel: 'Nigeria',
    isUeCountry: false
  },
  {
    value: 'NU',
    label: 'Niue',
    englishLabel: 'Niue',
    isUeCountry: false
  },
  {
    value: 'NO',
    label: 'Norv\u00e8ge',
    englishLabel: 'Norway',
    isUeCountry: false
  },
  {
    value: 'NC',
    label: 'Nouvelle-Cal\u00e9donie',
    englishLabel: 'New Caledonia',
    isUeCountry: false
  },
  {
    value: 'NZ',
    label: 'Nouvelle-Z\u00e9lande',
    englishLabel: 'New Zealand',
    isUeCountry: false
  },
  {
    value: 'OM',
    label: 'Oman',
    englishLabel: 'Oman',
    isUeCountry: false
  },
  {
    value: 'UG',
    label: 'Ouganda',
    englishLabel: 'Uganda',
    isUeCountry: false
  },
  {
    value: 'UZ',
    label: 'Ouzb\u00e9kistan',
    englishLabel: 'Uzbekistan',
    isUeCountry: false
  },
  {
    value: 'PK',
    label: 'Pakistan',
    englishLabel: 'Pakistan',
    isUeCountry: false
  },
  {
    value: 'PW',
    label: 'Palau',
    englishLabel: 'Palau',
    isUeCountry: false
  },
  {
    value: 'PS',
    label: 'Palestine',
    englishLabel: 'Palestinian Territory, Occupied',
    isUeCountry: false
  },
  {
    value: 'PA',
    label: 'Panama',
    englishLabel: 'Panama',
    isUeCountry: false
  },
  {
    value: 'PG',
    label: 'Papouasie-Nouvelle-Guin\u00e9e',
    englishLabel: 'Papua New Guinea',
    isUeCountry: false
  },
  {
    value: 'PY',
    label: 'Paraguay',
    englishLabel: 'Paraguay',
    isUeCountry: false
  },
  {
    value: 'NL',
    label: 'Pays-Bas',
    englishLabel: 'Netherlands',
    isUeCountry: true
  },
  {
    value: 'PE',
    label: 'P\u00e9rou',
    englishLabel: 'Peru',
    isUeCountry: false
  },
  {
    value: 'PH',
    label: 'Philippines',
    englishLabel: 'Philippines',
    isUeCountry: false
  },
  {
    value: 'PL',
    label: 'Pologne',
    englishLabel: 'Poland',
    isUeCountry: true
  },
  {
    value: 'PF',
    label: 'Polyn\u00e9sie fran\u00e7aise',
    englishLabel: 'French Polynesia',
    isUeCountry: false
  },
  {
    value: 'PR',
    label: 'Porto Rico',
    englishLabel: 'Puerto Rico',
    isUeCountry: false
  },
  {
    value: 'PT',
    label: 'Portugal',
    englishLabel: 'Portugal',
    isUeCountry: true
  },
  {
    value: 'QA',
    label: 'Qatar',
    englishLabel: 'Qatar',
    isUeCountry: false
  },
  {
    value: 'CF',
    label: 'R\u00e9publique centrafricaine',
    englishLabel: 'Central African Republic',
    isUeCountry: false
  },
  {
    value: 'DO',
    label: 'R\u00e9publique dominicaine',
    englishLabel: 'Dominican Republic',
    isUeCountry: false
  },
  {
    value: 'CZ',
    label: 'R\u00e9publique tch\u00e8que',
    englishLabel: 'Czech Republic',
    isUeCountry: true
  },
  {
    value: 'RE',
    label: 'R\u00e9union',
    englishLabel: 'Reunion',
    isUeCountry: false
  },
  {
    value: 'RO',
    label: 'Roumanie',
    englishLabel: 'Romania',
    isUeCountry: true
  },
  {
    value: 'GB',
    label: 'Royaume-Uni',
    englishLabel: 'United Kingdom',
    isUeCountry: false
  },
  {
    value: 'RU',
    label: 'Russie',
    englishLabel: 'Russian Federation',
    isUeCountry: false
  },
  {
    value: 'RW',
    label: 'Rwanda',
    englishLabel: 'RWANDA',
    isUeCountry: false
  },
  {
    value: 'BL',
    label: 'Saint-Barth\u00e9lemy',
    englishLabel: 'Saint-Barthélemy',
    isUeCountry: false
  },
  {
    value: 'KN',
    label: 'Saint-Christophe-et-Ni\u00e9v\u00e8s',
    englishLabel: 'Saint Kitts and Nevis',
    isUeCountry: false
  },
  {
    value: 'SH',
    label: 'Sainte-H\u00e9l\u00e8ne',
    englishLabel: 'Saint Helena',
    isUeCountry: false
  },
  {
    value: 'LC',
    label: 'Sainte-Lucie',
    englishLabel: 'Saint Lucia',
    isUeCountry: false
  },
  {
    value: 'SM',
    label: 'Saint-Marin',
    englishLabel: 'San Marino',
    isUeCountry: false
  },
  {
    value: 'MF',
    label: 'Saint-Martin (FR)',
    englishLabel: 'Saint-Martin (FR)',
    isUeCountry: false
  },
  {
    value: 'PM',
    label: 'Saint-Pierre-et-Miquelon',
    englishLabel: 'Saint Pierre and Miquelon',
    isUeCountry: false
  },
  {
    value: 'VC',
    label: 'Saint-Vincent-et-les-Grenadines',
    englishLabel: 'Saint Vincent and the Grenadines',
    isUeCountry: false
  },
  {
    value: 'WS',
    label: 'Samoa',
    englishLabel: 'Samoa',
    isUeCountry: false
  },
  {
    value: 'AS',
    label: 'Samoa am\u00e9ricaines',
    englishLabel: 'American Samoa',
    isUeCountry: false
  },
  {
    value: 'ST',
    label: 'Sao Tom\u00e9-et-Principe',
    englishLabel: 'Sao Tome and Principe',
    isUeCountry: false
  },
  {
    value: 'SN',
    label: 'S\u00e9n\u00e9gal',
    englishLabel: 'Senegal',
    isUeCountry: false
  },
  {
    value: 'RS',
    label: 'Serbie',
    englishLabel: 'Kosovo',
    isUeCountry: false
  },
  {
    value: 'SC',
    label: 'Seychelles',
    englishLabel: 'Seychelles',
    isUeCountry: false
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
    englishLabel: 'Sierra Leone',
    isUeCountry: false
  },
  {
    value: 'SG',
    label: 'Singapour',
    englishLabel: 'Singapore',
    isUeCountry: false
  },
  {
    value: 'SK',
    label: 'Slovaquie',
    englishLabel: 'Slovakia',
    isUeCountry: true
  },
  {
    value: 'SI',
    label: 'Slov\u00e9nie',
    englishLabel: 'Slovenia',
    isUeCountry: true
  },
  {
    value: 'SO',
    label: 'Somalie',
    englishLabel: 'Somalia',
    isUeCountry: false
  },
  {
    value: 'SD',
    label: 'Soudan',
    englishLabel: 'Sudan',
    isUeCountry: false
  },
  {
    value: 'LK',
    label: 'Sri-Lanka',
    englishLabel: 'Sri Lanka',
    isUeCountry: false
  },
  {
    value: 'SE',
    label: 'Su\u00e8de',
    englishLabel: 'Sweden',
    isUeCountry: true
  },
  {
    value: 'CH',
    label: 'Suisse',
    englishLabel: 'Switzerland',
    isUeCountry: false
  },
  {
    value: 'SR',
    label: 'Suriname',
    englishLabel: 'Suriname',
    isUeCountry: false
  },
  {
    value: 'SZ',
    label: 'Swaziland',
    englishLabel: 'Swaziland',
    isUeCountry: false
  },
  {
    value: 'SY',
    label: 'Syrie',
    englishLabel: 'Syrian Arab Republic',
    isUeCountry: false
  },
  {
    value: 'TJ',
    label: 'Tadjikistan',
    englishLabel: 'Tajikistan',
    isUeCountry: false
  },
  {
    value: 'TW',
    label: 'Ta\u00efwan',
    englishLabel: 'Taiwan, Province of China',
    isUeCountry: false
  },
  {
    value: 'TZ',
    label: 'Tanzanie',
    englishLabel: 'Tanzania, United Republic of',
    isUeCountry: false
  },
  {
    value: 'TD',
    label: 'Tchad',
    englishLabel: 'Chad',
    isUeCountry: false
  },
  {
    value: 'IO',
    label: "Territoire britannique de l'oc\u00e9an Indien",
    englishLabel: 'British Indian Ocean Territory',
    isUeCountry: false
  },
  {
    value: 'TH',
    label: 'Tha\u00eflande',
    englishLabel: 'Thailand',
    isUeCountry: false
  },
  {
    value: 'TL',
    label: 'Timor oriental',
    englishLabel: 'Timor-Leste',
    isUeCountry: false
  },
  {
    value: 'TG',
    label: 'Togo',
    englishLabel: 'Togo',
    isUeCountry: false
  },
  {
    value: 'TO',
    label: 'Tonga',
    englishLabel: 'Tonga',
    isUeCountry: false
  },
  {
    value: 'TT',
    label: 'Trinit\u00e9-et-Tobago',
    englishLabel: 'Trinidad and Tobago',
    isUeCountry: false
  },
  {
    value: 'TN',
    label: 'Tunisie',
    englishLabel: 'Tunisia',
    isUeCountry: false
  },
  {
    value: 'TM',
    label: 'Turkm\u00e9nistan',
    englishLabel: 'Turkmenistan',
    isUeCountry: false
  },
  {
    value: 'TR',
    label: 'Turquie',
    englishLabel: 'Turkey',
    isUeCountry: false
  },
  {
    value: 'TV',
    label: 'Tuvalu',
    englishLabel: 'Tuvalu',
    isUeCountry: false
  },
  {
    value: 'UA',
    label: 'Ukraine',
    englishLabel: 'Ukraine',
    isUeCountry: false
  },
  {
    value: 'UY',
    label: 'Uruguay',
    englishLabel: 'Uruguay',
    isUeCountry: false
  },
  {
    value: 'VU',
    label: 'Vanuatu',
    englishLabel: 'Vanuatu',
    isUeCountry: false
  },
  {
    value: 'VA',
    label: 'Vatican',
    englishLabel: 'Holy See (Vatican City State)',
    isUeCountry: false
  },
  {
    value: 'VE',
    label: 'Venezuela',
    englishLabel: 'Venezuela',
    isUeCountry: false
  },
  {
    value: 'VN',
    label: 'Vietnam',
    englishLabel: 'Viet Nam',
    isUeCountry: false
  },
  {
    value: 'WF',
    label: 'Wallis-et-Futuna',
    englishLabel: 'Wallis and Futuna',
    isUeCountry: false
  },
  {
    value: 'YE',
    label: 'Y\u00e9men',
    englishLabel: 'Yemen',
    isUeCountry: false
  },
  {
    value: 'ZM',
    label: 'Zambie',
    englishLabel: 'Zambia',
    isUeCountry: false
  },
  {
    value: 'ZW',
    label: 'Zimbabwe',
    englishLabel: 'Zimbabwe',
    isUeCountry: false
  }
];
